import Icon from "@Atom/Icon";
import Styles from "./styles.module.scss";
import { useState } from "react";

export default function AddLinkVideoModal({
  handleClose = () => {},
  linkUrl = "",
  handleSubmit = () => {},
  loading = false,
  error = "",
  isApply = false,
}) {
  const [link, setLink] = useState(linkUrl || "");
  return (
    <div className={Styles.container}>
      <div className={Styles.header}>
        <span>Masukan Link</span>

        <Icon
          icon={"cross"}
          color={"#0A0A0A"}
          size={24}
          className={Styles.cross}
          onClick={handleClose}
        />
      </div>

      <div className={Styles.content}>
        <span>Masukan Link Youtube dari Video Perkenalan Diri Kamu</span>

        <div className={Styles.input}>
          <div className={Styles.iconLink}>
            <Icon icon={"link"} size={20} color={"#1571DE"} />
          </div>

          <input
            placeholder="Masukan Link Youtube dari Video Perkenalan Diri Kamu"
            value={link}
            onChange={(e) => setLink(e.target.value)}
          />
        </div>
      </div>

      <div className={Styles.buttonWrapper}>
        {error && <span>*{error}</span>}
        {/* <span>*EROR</span> */}
        <div className={Styles.button}>
          <button disabled={loading} onClick={handleClose}>
            Batal
          </button>
          <button
            disabled={!link || loading}
            onClick={(e) => {
              if (isApply) {
                handleSubmit((prev) => ({
                  ...prev,
                  videoLink: link || "",
                }));
                handleClose();
              } else {
                handleSubmit(e, link, "video");
              }
            }}
          >
            {loading ? "Loading..." : "Simpan"}
          </button>
        </div>
      </div>
    </div>
  );
}
